module.exports = __webpack_public_path__ + "img/shutterstock_1271305915_490x340.2fa26448.jpg";